import React from 'react';
import { dateToStringFormat } from '@common/utils/date';
import {
  ConnectedIcon,
  DisconnectedIcon,
  WebsocketDisconnectedIcon,
} from '@common/utils/icons/icons';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import WebSocketConnectionStatus from 'models/enums/websocket-connection-status';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store';
import { selectRobotsData } from 'store/robots/robots-slice-selectors';

const RobotConnectionIcon: React.FC = () => {
  const { t } = useTranslation();

  const robotsData = useAppSelector((state) => selectRobotsData(state));

  return (
    <React.Fragment>
      <Tooltip
        title={
          <Stack>
            <Typography variant="inherit">
              {robotsData.currentRobot?.status?.active === false
                ? t('info-robot-disconnected')
                : robotsData.robotHubState === WebSocketConnectionStatus.DISCONNECTED
                  ? t('warning-websocket-not-connected')
                  : robotsData.currentRobot?.status?.active
                    ? t('info-robot-connected')
                    : t('info-robot-disconnected')}
            </Typography>
            {robotsData.currentRobot?.status?.lastConnection != null && (
              <Typography variant="inherit">{`${t('table-header-last-connection')} ${dateToStringFormat(
                robotsData.currentRobot.status.lastConnection,
              )}`}</Typography>
            )}
          </Stack>
        }
      >
        <Box p={1} display="flex" alignItems="center">
          {robotsData.currentRobot?.status?.active === false ? (
            <DisconnectedIcon color="action" />
          ) : robotsData.robotHubState === WebSocketConnectionStatus.DISCONNECTED ? (
            <WebsocketDisconnectedIcon color="warning" />
          ) : robotsData.currentRobot?.status?.active ? (
            <ConnectedIcon color="success" />
          ) : (
            <DisconnectedIcon color="action" />
          )}
        </Box>
      </Tooltip>
    </React.Fragment>
  );
};

export default RobotConnectionIcon;
